module.exports = __webpack_public_path__ + "img/cristofer-maximilian-uQDRDqpYJHI-unsplash.efd13416.jpg";